import { getApiUrl, apiFetch } from '../config/api';

/**
 * Load every row of a paginated list endpoint (`{ <key>: [...], total, page, page_size }`).
 *
 * `/api/customers` and `/api/products` answer 100 rows by default, so a screen that called them
 * once only ever saw the first 100 (#310). This asks for pages of `pageSize` (the API maximum is
 * 500) until `total` rows have arrived. Throws on an HTTP error so the caller can say so.
 *
 *   const customers = await fetchAllPages('/api/customers', 'customers');
 *   const active = await fetchAllPages('/api/customers', 'customers', { is_active: 'true' });
 */
export async function fetchAllPages(path, key, params = {}, pageSize = 500) {
  const rows = [];
  for (let page = 1; ; page += 1) {
    const query = new URLSearchParams({ ...params, page: String(page), page_size: String(pageSize) });
    const response = await apiFetch(getApiUrl(`${path}?${query}`));
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    const batch = data[key] || [];
    rows.push(...batch);
    const total = Number(data.total ?? rows.length);
    if (batch.length === 0 || batch.length < pageSize || rows.length >= total) return rows;
  }
}

export const fetchAllCustomers = (params) => fetchAllPages('/api/customers', 'customers', params);
export const fetchAllProducts = (params) => fetchAllPages('/api/products', 'products', params);

export default fetchAllPages;
